import { useState } from "react";
import BaseClient from "../helper/Baseclient";
import { APIEndpoints } from "../constants/APIEndpoints";

const useAuth = () => {
  const [authLoading, setAuthLoading] = useState(false);

  const userLogin = async (payload, { onSuccess, onFailed }) => {
    try {
      setAuthLoading(true);
      await BaseClient.post(APIEndpoints.userLogin, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
      });
    } finally {
      setAuthLoading(false);
    }
  };

  const fetchShopSettings = async (shopUrl, { onSuccess, onFailed }) => {
    try {
      if (!shopUrl) return;
      setAuthLoading(true);

      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const header = {
        "x-shopToken": token,
      };
      await BaseClient.get(
        APIEndpoints.shopSettings,
        {},
        {
          onSuccess: onSuccess,
          onFailed: onFailed,
          headers: header,
        }
      );
    } finally {
      setAuthLoading(false);
    }
  };

  return {
    authLoading,
    userLogin,
    fetchShopSettings,
  };
};

export default useAuth;
